import { TemplatePage } from './types';

const memorialDayPage: TemplatePage = {
  header: {
    color: '#D1D6D9',
    icon: 'images/video-templates/memorial-day.jpg',
    title: 'Memorial day Video Templates',
    title_meta: '500+ Customizable Holiday Video Templates',
    description_meta:
      'Pick easily customizable, beautiful and patriotic memorial day video templates to honor Veterans, to ' +
      'share your video on social media, send in email or embedded on your website!',
    description:
      'Memorial Day is a day for remembrance of those who have died in service, protecting the country. Pick ' +
      'from a variety of templates with waving flags, gentle flowers, and patriotic music.'
  },
  footer: {
    category: 'Memorial day',
    description:
      'Wave.video’s collection of <a href="https://en.wikipedia.org/wiki/Memorial_Day" target="_blank">Memorial Day</a> ' +
      'video templates, offers a selection of creative and patriotic templates to commemorate America’s fallen heroes. ' +
      'Each one can be easily customized for your personal needs, sent in email, shared on social media or ' +
      'embedded in your website! Wave.video is proud to honor and celebrate courageous Veterans. '
  },
  content: [
    {
      type: 'templates',
      title: 'Memorial Day',
      search: {
        category: '/Holidays & Occasions/Memorial Day'
      }
    },
    {
      type: 'stocks',
      title: 'Memorial Day',
      search: {
        name: 'memorial day'
      }
    },
    { type: 'calendar' }
  ]
};

export default memorialDayPage;
